import { render, staticRenderFns } from "./SiatRiepilogoPraticheStoricoModalComponent.vue?vue&type=template&id=2298b5cb&scoped=true"
import script from "./SiatRiepilogoPraticheStoricoModalComponent.vue?vue&type=script&lang=js"
export * from "./SiatRiepilogoPraticheStoricoModalComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatRiepilogoPraticheStoricoModalComponent.vue?vue&type=style&index=0&id=2298b5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298b5cb",
  null
  
)

export default component.exports